import { createContext, useContext } from 'react'

import { type FilterAndSort, FilterAndSortWrapper, TodoItemWrapper } from '@state/util/todoList'

export interface TodoListContext {
  filterAndSort: FilterAndSortWrapper
  updateFilterAndSort: (source: Partial<FilterAndSort>) => void
  selectedTask: TodoItemWrapper | undefined
  setSelectedTask: (task: TodoItemWrapper | undefined) => void
  selectedShelfId: string | undefined
  setSelectedShelfId: (shelfId: string | undefined) => void
  filteredTodoList: TodoItemWrapper[]
}

const todoListContext = createContext<TodoListContext | undefined>(undefined)

export function useTodoListContext() {
  const context = useContext(todoListContext)

  if (context === undefined) {
    throw new Error('useProductFinderContext must be used within a ProductFinderContext')
  }

  return context
}

export default todoListContext